import { css } from "@emotion/css";

import { grey, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createCommentStyles = ({
  spacing,
  borderRadius,
  palette,
}: Theme) => {
  return {
    root: css({
      display: "flex",
      margin: spacing([1, 0]),
    }),
    comment: css({
      padding: spacing(1),
      backgroundColor: white,
      border: `1px solid ${grey[300]}`,
      borderRadius: borderRadius.default,
      flexGrow: 1,
    }),
    text: css({
      color: palette.default.text,
    }),
  };
};
